import { t, tf } from "./i18n.js";
import { erzeugeAufnahmeEingabe, istCheckoutDart, letzterDart } from "./aufnahme-eingabe.js";
// ==========================================
// GOTCHA LOGIK (Aufwaerts-X01 mit Punkteklau)
//
// Regeln:
//  * Alle starten bei 0 und zaehlen HOCH Richtung Zielzahl (170/301/501).
//  * 3 Darts je Aufnahme, Eingabe wie bei Party X01 - seit 14.08.2026 ueber
//    den gemeinsamen Baustein Dart fuer Dart statt als getippte Summe.
//  * GOTCHA: Landet man nach seiner Aufnahme EXAKT auf dem Punktestand
//    eines Mitspielers, faellt dieser zurueck auf 0. (Nur fuer Staende
//    > 0 - sonst wuerde jede 0-Aufnahme am Anfang alle "treffen".)
//  * Sieg: Wer die Zielzahl EXAKT erreicht, gewinnt. Ueberwerfen ist Bust:
//    der Stand bleibt wie vor der Aufnahme.
//  * Double-Out ist seit 15.08.2026 im Setup zuschaltbar (Vorgabe AUS):
//    Dann muss der Dart, der die Zielzahl erreicht, ein Doppel oder das
//    Bullseye sein.
//
// Struktur bewusst 1:1 wie game-party.js (Setup-Liste, Undo-Snapshots,
// Eingabe-Baustein) - ein bekanntes, getestetes Muster statt eines neuen.
// ==========================================

let gotchaPlayers = [];
let gotchaTarget = 301;
let currentGotchaTurnIndex = 0;
let gotchaHistoryStack = [];
let gotchaDoubleOut = false;

// --- 1. SETUP ---

function addGotchaPlayer() {
  const input = document.getElementById("gotcha-player-input");
  const name = input.value.trim();

  if (name === "") return;
  if (gotchaPlayers.length >= 8) {
    showToast(t("js.gotcha.001"), "warning");
    return;
  }
  if (gotchaPlayers.some((p) => p.name.toLowerCase() === name.toLowerCase())) {
    showToast(t("js.gotcha.002"), "warning");
    return;
  }

  gotchaPlayers.push({ name: name, score: 0, dartsThrown: 0, gotchas: 0 });
  input.value = "";
  updateGotchaPlayerList();
}

function removeGotchaPlayer(index) {
  gotchaPlayers.splice(index, 1);
  updateGotchaPlayerList();
}

function updateGotchaPlayerList() {
  const list = document.getElementById("gotcha-player-list");
  if (!list) return;
  list.innerHTML = "";

  gotchaPlayers.forEach((p, index) => {
    const li = document.createElement("li");
    li.style.cssText =
      "display: flex; justify-content: space-between; align-items: center; background: #222; padding: 10px 15px; margin-bottom: 5px; border-radius: 6px;";

    // textContent statt innerHTML: Namen sind Nutzereingaben
    const nameSpan = document.createElement("span");
    nameSpan.style.cssText = "font-weight: bold; font-size: 1.1em;";
    nameSpan.textContent = `${index + 1}. ${p.name}`;

    const delBtn = document.createElement("button");
    delBtn.textContent = "X";
    delBtn.style.cssText =
      "background: var(--accent-red); color: white; border: none; border-radius: 4px; padding: 5px 12px; cursor: pointer; font-weight: bold;";
    delBtn.onclick = () => removeGotchaPlayer(index);

    li.appendChild(nameSpan);
    li.appendChild(delBtn);
    list.appendChild(li);
  });
}

function startGotchaGame() {
  // Gotcha lebt vom Klauen - alleine ergibt es keinen Sinn
  if (gotchaPlayers.length < 2) {
    showToast(t("js.gotcha.003"), "warning");
    return;
  }

  gotchaTarget = parseInt(
    document.getElementById("gotcha-target-score").value,
    10,
  ) || 301;
  gotchaDoubleOut = !!document.getElementById("chk-gotcha-double-out")?.checked;

  gotchaPlayers.forEach((p) => {
    p.score = 0;
    p.dartsThrown = 0;
    p.gotchas = 0;
  });

  currentGotchaTurnIndex = 0;
  gotchaHistoryStack = [];

  const undoBtn = document.getElementById("btn-undo-gotcha");
  if (undoBtn) undoBtn.style.display = "none";

  document.getElementById("gotcha-setup-screen").style.display = "none";
  document.getElementById("game-gotcha-screen").style.display = "block";

  // ERST sichtbar, DANN bauen - createDartboard misst beim Zeichnen.
  gotchaEingabe.baue();
  gotchaEingabe.leere();
  gotchaEingabe.aktualisiereSichtbarkeit();

  updateGotchaScoreboard();
  updateGotchaTurnIndicator();

  // Spielwache scharf (29.08.2026).
  spielwacheSpielGestartet("gotcha", sichereGotchaStand);
}

// ── Spielwache: sichern & wiederherstellen (29.08.2026) ─────────────────
// Eine halbe Aufnahme wird bewusst nicht gespiegelt (wie beim Undo).
function sichereGotchaStand() {
  return {
    players: gotchaPlayers,
    target: gotchaTarget,
    doubleOut: gotchaDoubleOut,
    turnIndex: currentGotchaTurnIndex,
  };
}

function stelleGotchaWieder(stand) {
  openGotchaSetup();
  gotchaPlayers = stand.players.map((p) => ({ ...p }));
  gotchaTarget = stand.target;
  gotchaDoubleOut = !!stand.doubleOut;
  currentGotchaTurnIndex = stand.turnIndex;
  gotchaHistoryStack = [];

  const zielFeld = document.getElementById("gotcha-target-score");
  if (zielFeld) zielFeld.value = gotchaTarget;
  const doppelHaken = document.getElementById("chk-gotcha-double-out");
  if (doppelHaken) doppelHaken.checked = gotchaDoubleOut;
  const undoBtn = document.getElementById("btn-undo-gotcha");
  if (undoBtn) undoBtn.style.display = "none";

  document.getElementById("gotcha-setup-screen").style.display = "none";
  document.getElementById("game-gotcha-screen").style.display = "block";
  gotchaEingabe.baue();
  gotchaEingabe.leere();
  gotchaEingabe.aktualisiereSichtbarkeit();
  updateGotchaScoreboard();
  updateGotchaTurnIndicator();
  spielwacheSpielGestartet("gotcha", sichereGotchaStand);
}

spielwacheRegistriereFortsetzen("gotcha", "Gotcha", stelleGotchaWieder);

function cancelGotchaGame() {
  cancelCurrentGame("game-gotcha-screen");
}

// --- 2. UNDO ---

function saveGotchaState() {
  gotchaHistoryStack.push({
    players: JSON.parse(JSON.stringify(gotchaPlayers)),
    turnIndex: currentGotchaTurnIndex,
  });
  document.getElementById("btn-undo-gotcha").style.display = "block";
}

function undoGotchaTurn() {
  if (gotchaHistoryStack.length === 0) return;

  const lastState = gotchaHistoryStack.pop();
  gotchaPlayers = lastState.players;
  currentGotchaTurnIndex = lastState.turnIndex;

  // Die Kacheln gehoeren zur zurueckgenommenen Aufnahme.
  gotchaEingabe.leere();

  updateGotchaScoreboard();
  updateGotchaTurnIndicator();

  if (gotchaHistoryStack.length === 0) {
    document.getElementById("btn-undo-gotcha").style.display = "none";
  }
}

// --- 3. ANZEIGE ---

function updateGotchaTurnIndicator() {
  const currentPlayer = gotchaPlayers[currentGotchaTurnIndex];
  if (!currentPlayer) return;

  const rest = gotchaTarget - currentPlayer.score;
  const info = document.getElementById("gotcha-info-display");
  if (info) {
    info.innerText =
      rest <= 180
        ? tf("js.gotcha.009", { p1: rest, p2: gotchaTarget })
        : tf("js.gotcha.005", { p1: rest, p2: gotchaTarget });
  }

  const zug = document.getElementById("gotcha-turn-display");
  if (zug) zug.innerText = tf("js.gotcha.006", { p1: currentPlayer.name });

  gotchaEingabe.zeichne();
}

function updateGotchaScoreboard() {
  renderPlayerCarousel(
    "gotcha-scoreboard",
    gotchaPlayers.map((p) => ({
      name: p.name,
      score: p.score,
      sub: p.gotchas > 0 ? `${p.gotchas}x Gotcha!` : (p.dartsThrown > 0 ? tf("js.friends.011", { p1: p.dartsThrown }) : ""),
    })),
    currentGotchaTurnIndex,
    { accent: "var(--accent)" },
  );
  // Nach jeder Standaenderung spiegeln (spielwache.js, 29.08.2026).
  if (typeof spielwacheTick === "function") spielwacheTick();
}

// --- 4. EINGABE ---

/** Eine Aufnahme werten.
 *
 *  @param {number} presetScore Summe der Aufnahme
 *  @param {Array|number} [wuerfe] Dartliste des Bausteins - oder nur ihre
 *                              Anzahl (alter Aufrufer/Test).
 *  @returns {boolean} false = abgelehnt, die Darts bleiben stehen. */
function submitGotchaScore(presetScore = null, wuerfe) {
  const score = Number(presetScore);
  if (!Number.isFinite(score)) return false;

  if (score > 180) {
    showToast(t("js.gotcha.004"), "warning");
    return false;
  }

  saveGotchaState();

  const liste = Array.isArray(wuerfe) ? wuerfe : null;
  const dartZahl = liste
    ? liste.length || 3
    : Number.isFinite(wuerfe) && wuerfe > 0
      ? wuerfe
      : 3;

  const player = gotchaPlayers[currentGotchaTurnIndex];
  const newScore = player.score + score;
  // Echte Dartzahl statt pauschal 3 (offener Punkt D4).
  player.dartsThrown += dartZahl;

  // Double-Out, wenn im Setup gewaehlt: Der Dart, der die Zielzahl EXAKT
  // erreicht, muss ein Doppel oder das Bullseye sein. Ohne Dartliste bleibt
  // es beim milderen Verhalten.
  const verfehltesFinish =
    gotchaDoubleOut &&
    newScore === gotchaTarget &&
    liste &&
    !istCheckoutDart(letzterDart(liste));

  if (newScore > gotchaTarget) {
    // Bust: exakt treffen ist Pflicht, der Stand bleibt stehen
    showToast(tf("js.gotcha.007", { p1: player.name, p2: newScore }), "error");
  } else if (verfehltesFinish) {
    // Wie ein Ueberwurf: Der Stand bleibt, wo er war. Sonst stuende der
    // Spieler auf der Zielzahl, ohne gewonnen zu haben - ein Zustand, aus
    // dem das Spiel keinen Ausweg mehr haette.
    showToast(tf("gotcha.bustDoppel", { p1: player.name }), "error");
  } else if (newScore === gotchaTarget) {
    player.score = newScore;
    updateGotchaScoreboard();
    spielwacheSpielBeendet();
    // Gemeinsamer Endbildschirm statt Toast + goHome (Produkttest
    // 29.08.2026): Rangliste nach Stand, Revanche mit denselben Spielern.
    setTimeout(() => {
      zeigeEndbildschirm({
        screenId: "game-gotcha-screen",
        titel: tf("js.ende.sieg", { p1: player.name }),
        untertitel: tf("js.gotcha.010", { p1: player.name, p2: gotchaTarget }),
        zeilen: [...gotchaPlayers]
          .sort((a, b) => b.score - a.score)
          .map((p) => ({ name: p.name, wert: p.score, aktiv: p === player })),
        kennzahlen: [],
        revanche: () => startGotchaGame(),
        setup: () => openGotchaSetup(),
      });
    }, 300);
    return true;
  } else {
    player.score = newScore;

    // GOTCHA: Gleichstand mit einem Mitspieler wirft diesen auf 0 zurueck.
    // Nur fuer Staende > 0 - sonst traefe jede Null-Aufnahme alle Starter.
    if (newScore > 0) {
      const getroffene = gotchaPlayers.filter(
        (p, i) => i !== currentGotchaTurnIndex && p.score === newScore,
      );
      getroffene.forEach((opfer) => {
        opfer.score = 0;
        player.gotchas += 1;
        showToast(tf("js.gotcha.008", { p1: opfer.name }), "warning", 4000);
      });
    }
  }

  currentGotchaTurnIndex = (currentGotchaTurnIndex + 1) % gotchaPlayers.length;

  updateGotchaScoreboard();
  updateGotchaTurnIndicator();
  return true;
}

// ---------------------------------------------------------------------------
// EINGABE (14.08.2026, Stufe 3): drei Darts statt Ziffernblock
//
// Die sechs Schnellwahlknoepfe (26/41/45/60/81/100) sind mit entfallen: Sie
// waren Abkuerzungen fuer haeufige Summen und haetten den Baustein umgangen -
// dieselbe Doppeldeutigkeit, die in Stufe 1 den Party-Ziffernblock gekostet
// hat. Die Wertung (Bust bei Ueberwerfen, Gotcha bei Gleichstand, Sieg bei
// exakter Zielzahl) bleibt unveraendert in submitGotchaScore().
// ---------------------------------------------------------------------------
const gotchaEingabe = erzeugeAufnahmeEingabe({
  modus: "gotcha",
  ziel: () => document.getElementById("aufnahme-gotcha"),
  aktiv: () =>
    document.getElementById("game-gotcha-screen")?.style.display !== "none" &&
    gotchaPlayers.length > 0,
  // Die ganze Liste, nicht nur ihre Laenge: submitGotchaScore braucht den
  // LETZTEN Dart fuer die Double-Out-Option.
  onAufnahme: (wuerfe, summe) => submitGotchaScore(summe, wuerfe),
});

// ---------------------------------------------------------------
// Bruecke zu window: Inline-Handler im HTML und andere Module greifen
// weiterhin global auf diese Funktionen zu.
// ---------------------------------------------------------------
Object.assign(window, {
  addGotchaPlayer,
  startGotchaGame,
  cancelGotchaGame,
  submitGotchaScore,
  undoGotchaTurn,
  gotchaEingabe,
});
